import { all, takeLatest } from "redux-saga/effects";

// Types
import { AuthTypes } from "store/ducks/auth";
import { ListCompaniesTypes, FetchCompanyTypes } from "store/ducks/companies";
import {
  ListPickingsTypes,
  InvoicePickingTypes,
  UpdatePickingTypes,
  AlterPickingTypes,
  deletePickingTypes,
  cancelPickingsTypes,
  PaginatePickingsTypes,
  PaginatePickingsLogTypes,
  ExportPickingsLogTypes,
  AllowShipPickingTypes,
  FetchPickingTypes,
  ExportPickingsTypes,
} from "store/ducks/pickings";
import {
  CreateVehicleTypes,
  DeleteVehicleTypes,
  FetchVehicleTypes,
  ListVehiclesTypes,
  PaginateVehiclesTypes,
  UpdateVehicleTypes,
} from "store/ducks/settings/vehicles";
import {
  CreateVehicleTypeTypes,
  DeleteVehicleTypeTypes,
  FetchVehicleTypeTypes,
  ListVehicleTypesTypes,
  PaginateVehicleTypesTypes,
  UpdateVehicleTypeTypes,
} from "store/ducks/settings/vehicle-types";
import {
  CreateCompanyDockTypes,
  DeleteCompanyDockTypes,
  FetchCompanyDockTypes,
  FetchDockTypes,
  ListCompanyDocksTypes,
  PaginateCompanyDocksTypes,
  UpdateCompanyDockTypes,
} from "store/ducks/settings/company-docks";
import {
  CreateJustificationTypes,
  DeleteJustificationTypes,
  FetchJustificationTypes,
  ListJustificationsTypes,
  PaginateJustificationsTypes,
  UpdateJustificationTypes,
} from "store/ducks/settings/justifications";
import {
  CreateBlockDateTypes,
  DeleteBlockDateTypes,
  FetchBlockDateTypes,
  PaginateBlockDatesTypes,
  UpdateBlockDateTypes,
} from "store/ducks/settings/block-dates";
import {
  CancelTransportTypes,
  CalendarViewTypes,
  CreateTransportTypes,
  DeleteTransportTypes,
  FetchTransportTypes,
  ExportTransportsTypes,
  ListAvailableTimeframesTypes,
  ListTransportsTypes,
  ListPanelTransportsTypes,
  PaginateTransportsTypes,
  SchedulingEditTypes,
  SchedulingTransportTypes,
  UpdateTransportTypes,
  PaginatePanelTypes,
  JustificateTransportTypes,
  ReplyJustificationTypes,
  CancelManyTransportTypes,
} from "store/ducks/transports";
import { UpdateUserTypes } from "store/ducks/settings/users";
import { ListClientsTypes, CreateClientTypes } from "store/ducks/clients";
import { ListCarriersTypes, CreateCarrierTypes } from "store/ducks/carriers";
import {
  CreateDockCarrierTypes,
  DeleteDockCarrierTypes,
} from "store/ducks/settings/dock-carrier";

import {
  FindOrCreateDriverTypes,
  UploadVaccineCertificateTypes,
  FetchVaccineCertificatesTypes,
} from "store/ducks/drivers";
import {
  CreatePickingFileTypes,
  DeletePickingFileTypes,
  ListPickingFilesTypes,
} from "store/ducks/picking-files";

import {
  CreatePickingQuarentineTypes,
  DeletePickingQuarentineTypes,
  FetchPickingQuarentineTypes,
  ListPickingQuarentinesTypes,
  PaginatePickingQuarentinesTypes,
  UpdatePickingQuarentineTypes,
} from "store/ducks/picking-quarentines";

import {
  CreateBusinessTypes,
  DeleteBusinessTypes,
  FetchBusinessTypes,
  ListBusinessTypes,
  PaginateBusinessTypes,
  UpdateBusinessTypes,
} from "store/ducks/business";

import { ListBoardingConditionsTypes } from "store/ducks/boarding_conditions";

import { ListCitiesTypes } from "store/ducks/cities";

import {
  CreateTransportFileTypes,
  DeleteTransportFileTypes,
  ListTransportFilesTypes,
} from "store/ducks/transport-files";

import { CepTypes } from "store/ducks/cep";
import { ListClientTypesTypes } from "store/ducks/client-types";
import { FetchListCarrierContactTypes } from "store/ducks/carrier-contact";

import {
  PaginateOrdersFOBTypes,
  PaginateScheduledOrdersFOBTypes,
  FetchOrderFOBTypes,
  UpdateOrderFOBTypes,
  UpdateInvoiceOrderFOBTypes,
  CancelScheduledOrderFOBTypes,
  SchedulingOrderFOBTypes,
  FetchScheduledOrderFOBTypes,
  UpdateScheduledOrderFOBTypes,
  CreateOrderFOBTypes,
  ExportSchedulingOrderFOBTypes,
  DeleteOrderScheduledOrderFOBTypes,
  DeleteOrderFOBTypes,
  ImportWriteOffFobTypes,
  UploadDeliveryReceiptSchedulingFOBTypes,
  FetchFileSchedulingFobTypes,
} from "store/ducks/ordersFob";

// Sagas
import {
  authRehydrateAccessToken,
  authLoginRequest,
  authLogoutRequest,
  authFirebaseLoginRequest,
} from "./auth";
import { listCompaniesRequest, fetchCompanyRequest } from "./companies";
import {
  listPickingsRequest,
  invoicePickingRequest,
  deletePickingRequest,
  updatePickingRequest,
  paginatePickingsRequest,
  paginatePickingsLogRequest,
  exportPickingsLogRequest,
  allowShipPickingRequest,
  cancelPickingsRequest,
  alterPickingRequest,
  fetchPickingRequest,
  exportPickingsRequest,
} from "./pickings";
import {
  createVehicleRequest,
  deleteVehicleRequest,
  fetchVehicleRequest,
  listVehiclesRequest,
  paginateVehiclesRequest,
  updateVehicleRequest,
} from "./settings/vehicles";
import {
  createVehicleTypeRequest,
  deleteVehicleTypeRequest,
  fetchVehicleTypeRequest,
  listVehicleTypesRequest,
  paginateVehicleTypesRequest,
  updateVehicleTypeRequest,
} from "./settings/vehicle-types";
import {
  createCompanyDockRequest,
  deleteCompanyDockRequest,
  fetchCompanyDockRequest,
  fetchDockRequest,
  listCompanyDocksRequest,
  paginateCompanyDocksRequest,
  updateCompanyDockRequest,
} from "./settings/company-docks";
import {
  createJustificationRequest,
  deleteJustificationRequest,
  fetchJustificationRequest,
  listJustificationsRequest,
  paginateJustificationsRequest,
  updateJustificationRequest,
} from "./settings/justifications";
import {
  createBlockDateRequest,
  deleteBlockDateRequest,
  fetchBlockDateRequest,
  paginateBlockDatesRequest,
  updateBlockDateRequest,
} from "./settings/block-dates";
import { updateUserRequest } from "./settings/users";
import {
  cancelTransportRequest,
  fetchCalendarViewRequest,
  createTransportRequest,
  deleteTransportRequest,
  fetchTransportRequest,
  exportTransportsRequest,
  listAvailableTimeframesRequest,
  listTransportsRequest,
  listPanelTransportsRequest,
  paginateTransportsRequest,
  schedulingEditRequest,
  schedulingTransportsRequest,
  updateTransportsRequest,
  paginatePanelRequest,
  justificateTransportsRequest,
  replyJustificationRequest,
  cancelManyTransportRequest,
} from "./transports";
import { listClientsRequest, createClientRequest } from "./clients";
import { listCarriersRequest, createCarrierRequest } from "./carriers";
import {
  createDockCarrierRequest,
  deleteDockCarrierRequest,
} from "./settings/dock-carrier";

import { ListShippingsTypes } from "store/ducks/shippings";
import { listShippingsRequest } from "./shippings";
import { ListProductsTypes, FetchProductTypes } from "store/ducks/products";
import { listProductsRequest, fetchProductRequest } from "./products";
import {
  fetchVaccineCertificates,
  findOrCreateDriverRequest,
  uploadVaccineCertificate,
} from "./drivers";
import {
  deletePickingFileRequest,
  createPickingFileRequest,
  listPickingFilesRequest,
} from "./picking-files";

import {
  createPickingQuarentineRequest,
  deletePickingQuarentineRequest,
  fetchPickingQuarentineRequest,
  listPickingQuarentinesRequest,
  paginatePickingQuarentinesRequest,
  updatePickingQuarentineRequest,
} from "./picking-quarentines";

import {
  createBusinessRequest,
  deleteBusinessRequest,
  fetchBusinessRequest,
  listBusinessRequest,
  paginateBusinessRequest,
  updateBusinessRequest,
} from "./business";

import { listBoardingConditionsRequest } from "./boarding_conditions";
import { listCitiesRequest } from "./cities";

import {
  deleteTransportFileRequest,
  createTransportFileRequest,
  listTransportFilesRequest,
} from "./transport-files";

import { fetchCepRequest } from "./cep";
import { listClientTypesRequest } from "./client-types";
import { fetchListCarrierContactRequest } from "./carrier-contact";

import {
  paginateOrdersFOBRequest,
  paginateScheduledOrdersFOBRequest,
  fetchOrderFOBRequest,
  updateOrderFOBRequest,
  updateInvoiceOrderFOBRequest,
  schedulingOrderFOBRequest,
  cancelScheduledOrderFOBRequest,
  fetchScheduledOrderFOBRequest,
  updateScheduledOrderFOBRequest,
  createOrderFOBRequest,
  exportSchedulingOrderFOBRequest,
  deleteOrderScheduledOrderFOBRequest,
  deleteOrderFOBRequest,
  importWriteOffFobRequest,
  fetchFileSchedulingFobActionsRequest,
  uploadDeliveryReceiptSchedulingFOBActionsRequest,
} from "./ordersFob";

import { fetchZohoEmbedUrlRequest } from './zohoDashboard/fetchZohoEmbedUrl';
import { FetchEmbedZohoTypes } from 'store/ducks/zohoDashboard';
import { FetchInvoiceFilesTypes } from '../ducks/invoices/fetch-invoice-file';
import { fetchInvoiceFileRequest } from './invoices';

export default function* rootSaga() {
  yield all([
    // auth
    takeLatest("persist/REHYDRATE", authRehydrateAccessToken),
    takeLatest(AuthTypes.LOGIN_REQUEST, authLoginRequest),
    takeLatest(AuthTypes.LOGOUT_REQUEST, authLogoutRequest),
    takeLatest(AuthTypes.FIREBASE_LOGIN_REQUEST, authFirebaseLoginRequest),

    // companies
    takeLatest(ListCompaniesTypes.REQUEST, listCompaniesRequest),
    takeLatest(FetchCompanyTypes.REQUEST, fetchCompanyRequest),

    // pickings
    takeLatest(ListPickingsTypes.REQUEST, listPickingsRequest),
    takeLatest(InvoicePickingTypes.REQUEST, invoicePickingRequest),
    takeLatest(UpdatePickingTypes.REQUEST, updatePickingRequest),
    takeLatest(PaginatePickingsTypes.REQUEST, paginatePickingsRequest),
    takeLatest(PaginatePickingsLogTypes.REQUEST, paginatePickingsLogRequest),
    takeLatest(ExportPickingsLogTypes.REQUEST, exportPickingsLogRequest),
    takeLatest(deletePickingTypes.REQUEST, deletePickingRequest),
    takeLatest(AllowShipPickingTypes.REQUEST, allowShipPickingRequest),
    takeLatest(cancelPickingsTypes.REQUEST, cancelPickingsRequest),
    takeLatest(AlterPickingTypes.REQUEST, alterPickingRequest),
    takeLatest(FetchPickingTypes.REQUEST, fetchPickingRequest),
    takeLatest(ExportPickingsTypes.REQUEST, exportPickingsRequest),

    // settings vehicles
    takeLatest(CreateVehicleTypes.REQUEST, createVehicleRequest),
    takeLatest(DeleteVehicleTypes.REQUEST, deleteVehicleRequest),
    takeLatest(FetchVehicleTypes.REQUEST, fetchVehicleRequest),
    takeLatest(ListVehiclesTypes.REQUEST, listVehiclesRequest),
    takeLatest(PaginateVehiclesTypes.REQUEST, paginateVehiclesRequest),
    takeLatest(UpdateVehicleTypes.REQUEST, updateVehicleRequest),

    // settings vehicle type
    takeLatest(CreateVehicleTypeTypes.REQUEST, createVehicleTypeRequest),
    takeLatest(DeleteVehicleTypeTypes.REQUEST, deleteVehicleTypeRequest),
    takeLatest(FetchVehicleTypeTypes.REQUEST, fetchVehicleTypeRequest),
    takeLatest(ListVehicleTypesTypes.REQUEST, listVehicleTypesRequest),
    takeLatest(PaginateVehicleTypesTypes.REQUEST, paginateVehicleTypesRequest),
    takeLatest(UpdateVehicleTypeTypes.REQUEST, updateVehicleTypeRequest),

    // settings company docks
    takeLatest(CreateCompanyDockTypes.REQUEST, createCompanyDockRequest),
    takeLatest(DeleteCompanyDockTypes.REQUEST, deleteCompanyDockRequest),
    takeLatest(FetchCompanyDockTypes.REQUEST, fetchCompanyDockRequest),
    takeLatest(FetchDockTypes.REQUEST, fetchDockRequest),
    takeLatest(ListCompanyDocksTypes.REQUEST, listCompanyDocksRequest),
    takeLatest(PaginateCompanyDocksTypes.REQUEST, paginateCompanyDocksRequest),
    takeLatest(UpdateCompanyDockTypes.REQUEST, updateCompanyDockRequest),

    // setting justifications
    takeLatest(CreateJustificationTypes.REQUEST, createJustificationRequest),
    takeLatest(DeleteJustificationTypes.REQUEST, deleteJustificationRequest),
    takeLatest(FetchJustificationTypes.REQUEST, fetchJustificationRequest),
    takeLatest(ListJustificationsTypes.REQUEST, listJustificationsRequest),
    takeLatest(
      PaginateJustificationsTypes.REQUEST,
      paginateJustificationsRequest
    ),
    takeLatest(UpdateJustificationTypes.REQUEST, updateJustificationRequest),

    // transports
    takeLatest(CancelTransportTypes.REQUEST, cancelTransportRequest),
    takeLatest(CreateTransportTypes.REQUEST, createTransportRequest),
    takeLatest(DeleteTransportTypes.REQUEST, deleteTransportRequest),
    takeLatest(FetchTransportTypes.REQUEST, fetchTransportRequest),
    takeLatest(ExportTransportsTypes.REQUEST, exportTransportsRequest),
    takeLatest(
      ListAvailableTimeframesTypes.REQUEST,
      listAvailableTimeframesRequest
    ),
    takeLatest(ListTransportsTypes.REQUEST, listTransportsRequest),
    takeLatest(ListPanelTransportsTypes.REQUEST, listPanelTransportsRequest),
    takeLatest(PaginateTransportsTypes.REQUEST, paginateTransportsRequest),
    takeLatest(SchedulingEditTypes.REQUEST, schedulingEditRequest),
    takeLatest(SchedulingTransportTypes.REQUEST, schedulingTransportsRequest),
    takeLatest(UpdateTransportTypes.REQUEST, updateTransportsRequest),
    takeLatest(CalendarViewTypes.REQUEST, fetchCalendarViewRequest),
    takeLatest(PaginatePanelTypes.REQUEST, paginatePanelRequest),
    takeLatest(JustificateTransportTypes.REQUEST, justificateTransportsRequest),
    takeLatest(ReplyJustificationTypes.REQUEST, replyJustificationRequest),
    takeLatest(CancelManyTransportTypes.REQUEST, cancelManyTransportRequest),

    // Clients
    takeLatest(ListClientsTypes.REQUEST, listClientsRequest),
    takeLatest(CreateClientTypes.REQUEST, createClientRequest),

    // Carriers
    takeLatest(ListCarriersTypes.REQUEST, listCarriersRequest),
    takeLatest(CreateCarrierTypes.REQUEST, createCarrierRequest),

    // settings block dates
    takeLatest(CreateBlockDateTypes.REQUEST, createBlockDateRequest),
    takeLatest(DeleteBlockDateTypes.REQUEST, deleteBlockDateRequest),
    takeLatest(FetchBlockDateTypes.REQUEST, fetchBlockDateRequest),
    takeLatest(PaginateBlockDatesTypes.REQUEST, paginateBlockDatesRequest),
    takeLatest(UpdateBlockDateTypes.REQUEST, updateBlockDateRequest),

    // users
    takeLatest(UpdateUserTypes.REQUEST, updateUserRequest),

    // settings dock carrier
    takeLatest(CreateDockCarrierTypes.REQUEST, createDockCarrierRequest),
    takeLatest(DeleteDockCarrierTypes.REQUEST, deleteDockCarrierRequest),

    // shippings
    takeLatest(ListShippingsTypes.REQUEST, listShippingsRequest),

    // products
    takeLatest(ListProductsTypes.REQUEST, listProductsRequest),
    takeLatest(FetchProductTypes.REQUEST, fetchProductRequest),

    // drivers
    takeLatest(FindOrCreateDriverTypes.REQUEST, findOrCreateDriverRequest),
    takeLatest(UploadVaccineCertificateTypes.REQUEST, uploadVaccineCertificate),
    takeLatest(FetchVaccineCertificatesTypes.REQUEST, fetchVaccineCertificates),

    // picking-files
    takeLatest(CreatePickingFileTypes.REQUEST, createPickingFileRequest),
    takeLatest(DeletePickingFileTypes.REQUEST, deletePickingFileRequest),
    takeLatest(ListPickingFilesTypes.REQUEST, listPickingFilesRequest),

    // picking-quarentines
    takeLatest(
      CreatePickingQuarentineTypes.REQUEST,
      createPickingQuarentineRequest
    ),
    takeLatest(
      DeletePickingQuarentineTypes.REQUEST,
      deletePickingQuarentineRequest
    ),
    takeLatest(
      FetchPickingQuarentineTypes.REQUEST,
      fetchPickingQuarentineRequest
    ),
    takeLatest(
      ListPickingQuarentinesTypes.REQUEST,
      listPickingQuarentinesRequest
    ),
    takeLatest(
      PaginatePickingQuarentinesTypes.REQUEST,
      paginatePickingQuarentinesRequest
    ),
    takeLatest(
      UpdatePickingQuarentineTypes.REQUEST,
      updatePickingQuarentineRequest
    ),

    // business
    takeLatest(CreateBusinessTypes.REQUEST, createBusinessRequest),
    takeLatest(DeleteBusinessTypes.REQUEST, deleteBusinessRequest),
    takeLatest(FetchBusinessTypes.REQUEST, fetchBusinessRequest),
    takeLatest(ListBusinessTypes.REQUEST, listBusinessRequest),
    takeLatest(PaginateBusinessTypes.REQUEST, paginateBusinessRequest),
    takeLatest(UpdateBusinessTypes.REQUEST, updateBusinessRequest),

    // boarding-conditions
    takeLatest(
      ListBoardingConditionsTypes.REQUEST,
      listBoardingConditionsRequest
    ),

    // cities
    takeLatest(ListCitiesTypes.REQUEST, listCitiesRequest),

    // picking-files
    takeLatest(CreateTransportFileTypes.REQUEST, createTransportFileRequest),
    takeLatest(DeleteTransportFileTypes.REQUEST, deleteTransportFileRequest),
    takeLatest(ListTransportFilesTypes.REQUEST, listTransportFilesRequest),

    // cep
    takeLatest(CepTypes.REQUEST, fetchCepRequest),

    // settings-client-types
    takeLatest(ListClientTypesTypes.REQUEST, listClientTypesRequest),

    // Carrier Contact
    takeLatest(
      FetchListCarrierContactTypes.REQUEST,
      fetchListCarrierContactRequest
    ),

    // Orders FOB
    takeLatest(PaginateOrdersFOBTypes.REQUEST, paginateOrdersFOBRequest),
    takeLatest(
      PaginateScheduledOrdersFOBTypes.REQUEST,
      paginateScheduledOrdersFOBRequest
    ),
    takeLatest(FetchOrderFOBTypes.REQUEST, fetchOrderFOBRequest),
    takeLatest(UpdateOrderFOBTypes.REQUEST, updateOrderFOBRequest),
    takeLatest(SchedulingOrderFOBTypes.REQUEST, schedulingOrderFOBRequest),
    takeLatest(
      CancelScheduledOrderFOBTypes.REQUEST,
      cancelScheduledOrderFOBRequest
    ),
    takeLatest(
      FetchScheduledOrderFOBTypes.REQUEST,
      fetchScheduledOrderFOBRequest
    ),
    takeLatest(
      UpdateScheduledOrderFOBTypes.REQUEST,
      updateScheduledOrderFOBRequest
    ),
    takeLatest(CreateOrderFOBTypes.REQUEST, createOrderFOBRequest),
    takeLatest(
      UpdateInvoiceOrderFOBTypes.REQUEST,
      updateInvoiceOrderFOBRequest
    ),
    takeLatest(
      ExportSchedulingOrderFOBTypes.REQUEST,
      exportSchedulingOrderFOBRequest
    ),
    takeLatest(
      DeleteOrderScheduledOrderFOBTypes.REQUEST,
      deleteOrderScheduledOrderFOBRequest
    ),
    takeLatest(DeleteOrderFOBTypes.REQUEST, deleteOrderFOBRequest),
    takeLatest(ImportWriteOffFobTypes.REQUEST, importWriteOffFobRequest),

    takeLatest(
      UploadDeliveryReceiptSchedulingFOBTypes.REQUEST,
      uploadDeliveryReceiptSchedulingFOBActionsRequest
    ),
    takeLatest(
      FetchFileSchedulingFobTypes.REQUEST,
      fetchFileSchedulingFobActionsRequest
    ),
    //zoho-embed-url-temporary
    takeLatest(FetchEmbedZohoTypes.REQUEST,fetchZohoEmbedUrlRequest),

    //fetch-invoice-file
    takeLatest(FetchInvoiceFilesTypes.REQUEST, fetchInvoiceFileRequest),
  ]);
}
